module.exports = __webpack_public_path__ + "media/question3_en.f3a87cd4.mp3";